import React from 'react';
import {
  BarChart, Bar,
  LineChart, Line,
  ScatterChart, Scatter,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { Typography } from 'antd';

const { Text } = Typography;

const PALETTE = ['#b6ce3b', '#7a9c2e', '#4d6b1f', '#94a857', '#d9e8a3'];

const ChartBlock = ({ spec }) => {
  const { type, title, x_key: xKey, y_keys: yKeys, y_label: yLabel, data } = spec;

  const axes = (
    <>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        dataKey={xKey}
        interval={0}
        angle={data.length > 6 ? -30 : 0}
        textAnchor={data.length > 6 ? 'end' : 'middle'}
        height={data.length > 6 ? 90 : 30}
        tick={{ fontSize: 11 }}
      />
      <YAxis
        tick={{ fontSize: 11 }}
        label={yLabel ? { value: yLabel, angle: -90, position: 'insideLeft', fontSize: 11 } : undefined}
        width={80}
      />
      <Tooltip />
      {yKeys.length > 1 && <Legend />}
    </>
  );

  let chart;
  if (type === 'line') {
    chart = (
      <LineChart data={data}>
        {axes}
        {yKeys.map((key, i) => (
          <Line key={key} dataKey={key} stroke={PALETTE[i % PALETTE.length]} dot={data.length <= 30} />
        ))}
      </LineChart>
    );
  } else if (type === 'scatter') {
    chart = (
      <ScatterChart data={data}>
        {axes}
        {yKeys.map((key, i) => (
          <Scatter key={key} dataKey={key} fill={PALETTE[i % PALETTE.length]} />
        ))}
      </ScatterChart>
    );
  } else {
    // bar and grouped_bar
    chart = (
      <BarChart data={data}>
        {axes}
        {yKeys.map((key, i) => (
          <Bar key={key} dataKey={key} fill={PALETTE[i % PALETTE.length]} />
        ))}
      </BarChart>
    );
  }

  return (
    <div className="agent-chart-block">
      {title && <Text strong>{title}</Text>}
      <ResponsiveContainer width="100%" height={340}>
        {chart}
      </ResponsiveContainer>
    </div>
  );
};

export default ChartBlock;
